import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import {
    BannerState,
    DialogState,
    type CopilotAccountOption,
} from '../store/schema/CopilotAccountPickerStoreSchema';
import type { MailboxInfo } from 'owa-client-types';

export const setAccountOptionsMutator: (options: CopilotAccountOption[]) => void = mutatorAction(
    'setAccountOptionsMutator',
    (options: CopilotAccountOption[]): void => {
        const store = getStore();
        store.accountOptions = options;
    }
);
export const setDialogStateMutator: (dialogState: DialogState) => void = mutatorAction(
    'setDialogStateMutator',
    (dialogState: DialogState): void => {
        getStore().dialogState = dialogState;
    }
);

export const setCurrentAccountMutator: (account: MailboxInfo) => void = mutatorAction(
    'setCurrentAccountMutator',
    (account: MailboxInfo): void => {
        getStore().currentAccount = account;
    }
);

export const setUnsavedSelectedAccountMutator: (account: MailboxInfo | null) => void =
    mutatorAction('setUnsavedSelectedAccountMutator', (account: MailboxInfo | null): void => {
        getStore().unsavedSelectedAccount = account;
    });

export const resetCopilotAccountPickerDialogStoreMutator: () => void = mutatorAction(
    'resetCopilotAccountPickerDialogStoreMutator',
    (): void => {
        const store = getStore();
        store.dialogState = DialogState.CLOSED;
        store.currentAccount = null;
        store.unsavedSelectedAccount = null;
        store.accountOptions = [];
        store.bannerState = BannerState.HIDDEN;
    }
);

export const setBannerStateMutator: (bannerState: BannerState) => void = mutatorAction(
    'setBannerStateMutator',
    (bannerState: BannerState): void => {
        getStore().bannerState = bannerState;
    }
);
